import {EditorPointTransformTranslate} from "../editor/editor-point-transform-translate";
import {TransformInteractionState} from "../abstract-transform";
import {Feature, GeoJSON} from "geojson";
import {ViewSimpleSelect} from "../view/view-simple-select";
import {SnapMode, SnapPoint} from "../../snap";
import {MapEvent} from "../../../document/model/map";

export class LocationPickerPointTransformTranslate extends EditorPointTransformTranslate {

    showHistory(state: TransformInteractionState): boolean {
        return false;
    }

    getSupportedSnapModes(): SnapMode[] {
        return [];
    }

    canSave(state: TransformInteractionState): boolean {
        return !!state.featureID;
    }

    display(state: TransformInteractionState, geojson: GeoJSON & Feature, display: (geojson: GeoJSON) => void): any {
        ViewSimpleSelect.prototype.display.apply(this, arguments);
    }

    save(state: TransformInteractionState, nextInteraction: string | undefined = undefined) {
        super.save(state, nextInteraction);
        let message = {
            action: 'location_picked',
            coordinates: this.transformedFeature.getCoordinates()
        };

        console.debug('Posting message', message);

        window.parent.postMessage(JSON.stringify(message), "*");

        this.controller.interaction.clearTmpGeometries();
        this.controller.interaction.addTmpGeometries([this.transformedFeature?.toGeoJSON() as Feature])
    }


    async onClick(state: any, e: MapboxDraw.MapMouseEvent): Promise<void> {
        let snapPoint = this.controller.snapUtility.getSnapPoint(e);
        this.transform(state, e, snapPoint);
        this._generateVertexMarkers(this.transformedFeature?.toGeoJSON() as Feature, this.getVertexIcon())
        this.controller.mapInstance.fire(MapEvent.PinChanged, {feature: (this.transformedFeature?.toGeoJSON() as Feature)});
    }

    async onMouseUp(state: TransformInteractionState, e: mapboxgl.MapMouseEvent): Promise<void> {
        super.onMouseUp(state, e);
        this.controller.mapInstance.fire(MapEvent.PinChanged, {feature: (this.transformedFeature?.toGeoJSON() as Feature)});
    }

    /*public transform(state: TransformInteractionState, e: MapMouseEvent, snapPoint: SnapPoint) {
        super.transform(state, e, snapPoint);
        this.controller.mapInstance.fire(MapEvent.PinChanged, {feature: (this.transformedFeature.toGeoJSON() as Feature)});

    }*/

}
